module.exports = __webpack_public_path__ + "static/media/pen.75769cbd.svg";